let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a5zka")).then(() => parcelRequire('38FZt'));